/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Shipping_Adjustment_Link_FailedInputs */

const en_shipping_adjustment_link_failed = /** @type {(inputs: Shipping_Adjustment_Link_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Shipping adjustment created, but payment link failed: ${i?.message}`)
};

const es_shipping_adjustment_link_failed = /** @type {(inputs: Shipping_Adjustment_Link_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El ajuste de envio se creo, pero fallo el link de pago: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Shipping adjustment created, but payment link failed: {message}" |
*
* @param {Shipping_Adjustment_Link_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const shipping_adjustment_link_failed = /** @type {((inputs: Shipping_Adjustment_Link_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Adjustment_Link_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_adjustment_link_failed(inputs)
	return es_shipping_adjustment_link_failed(inputs)
});